import React, { useEffect, useRef, useState } from 'react'
import VirtualizedSelect from '../../Select/SelectVirtualized'
import { useIntl } from 'react-intl'
import { usePipelineStore } from '../../../stores/PipelineStore'
import { useCustomeStore } from '../../../stores/CustomeStore'
import { nanoid } from 'nanoid'
import { Product, ProductLabels, ProductUnits } from '../../../interfaces/Product'
import { SelectOption } from '../../../interfaces/SelectOption'
import { ListProduct, PipelineDataProduct } from '../../../interfaces/Pipeline'
import { changeValueIfStringIntoNumber, currencyFormatter, formatDateWithDayName, customThousandSeparatorDot, getDateOnly, isInvalidDotInput, unformatNumberInput, isValidDateFormat, onlyNumberInput } from '../../../functions/general'
import useUser from '../../../hooks/User'
import { checkIsCompanyElgisa, checkIsCompanyEsb, checkIsCompanyHarriette, checkIsCompanyMeratus, checkIsCompanyTanrise, isDisabledPriceProduct } from '../../../functions/customCase'
import clsx from 'clsx'
import Select from 'react-select'
import useHandleChangeProduct from '../../../hooks/useHandleChangeProduct'
import { currencylocales } from '../../../interfaces/Options'
import Swal from 'sweetalert2'
import useHandleChangeResultPriceAndTotal from '../../../hooks/useHandleChangeResultPriceAndTotal'
import { KTSVG } from '../../../_metronic/helpers'
import { useProductStore } from '../../../stores/ProductStore'
import { useSettingsStore } from '../../../stores/SettingsStore'
import { DatePicker } from 'rsuite'
import useTodayRange from '../../../hooks/TodayRange'
import moment from 'moment-timezone'
import { v4 as uuidv4 } from 'uuid'
import { Progress } from '../../../interfaces/Progress'
import LabelTooltip from '../../General/LabelTooltip'

interface SelectOptionProduct extends SelectOption {
    sku?: string;
    note?: string;
    productUnits?: ProductUnits[];
    alias?: string;
    price?: number;
    vatPercentage?: number;
    isUsingVat?: boolean;
    labels?: ProductLabels[];
}

interface SelectProducUnit extends SelectOption {
    alias?: string;
    note?: string;
}

interface ProductPipelineMainProps {
    products: Product[]
    productLoading: boolean
    listProducts: ListProduct[]
    setListProducts: (products: ListProduct[]) => void
    typeForm?: 'default' | 'addLog'
    onModalClose?: () => void
    selectedProgress?: Progress
    completeProducts?: Product[]
}

const ProductPipelineMain = ({ products, productLoading, listProducts, setListProducts, typeForm = 'default', onModalClose, selectedProgress, completeProducts }: ProductPipelineMainProps) => {
    const intl = useIntl()
    const user = useUser()
    const { selectMultiPipeline } = usePipelineStore()
    const { roleId, companyId } = useCustomeStore()
    const { settings } = useSettingsStore()
    const [productData, setProductData] = useState<SelectOptionProduct[]>([])
    const [dataProduct, setDataProduct] = useState<PipelineDataProduct>({
        productId: "",
        productName: "",
        productSku: "",
        productNote: "",
        leadProductNotes: "",
        productUnits: [],
        productPrice: 0,
        productVatPercentage: 0,
        productIsUsingVat: false,
        productLabels: []
    });
    const [isIncludeVat, setIsIncludeVat] = useState<boolean>(false);
    const [originalPriceProduct, setOriginalPriceProduct] = useState<string>("");
    const [qtyProduct, setQtyProduct] = useState<string>("");
    const [hppProduct, setHppProduct] = useState<string>("");
    const [priceProduct, setPriceProduct] = useState<string>("");
    const [vatProduct, setVatProduct] = useState<string>("");
    const [discountProduct, setDiscountProduct] = useState<string>("");
    const [isDataProduct, setIsDataProduct] = useState<boolean>(false);
    const [isUnitProduct, setIsUnitProduct] = useState<boolean>(false);
    const [totalProduct, setTotalProduct] = useState<string>("");
    const [unitProduct, setUnitProduct] = useState<SelectProducUnit>({ value: "", label: "", alias: "" });
    const [unitData, setUnitData] = useState<SelectProducUnit[]>([]);
    const [discountType, setDiscountType] = useState<'NOMINAL' | 'PERCENTAGE'>('NOMINAL');
    const [showDiscountDropdown, setShowDiscountDropdown] = useState<boolean>(false);
    const { handleChangeProduct: handleHppChange } = useHandleChangeProduct({ setValueInputProduct: setHppProduct })
    const { handleChangeProduct: handlePriceChange } = useHandleChangeProduct({ setValueInputProduct: setPriceProduct })
    const { handleChangeProduct: handleDiscountChange } = useHandleChangeProduct({ setValueInputProduct: setDiscountProduct })
    const { handleChangeProduct: handleNominalChange } = useHandleChangeProduct({ setValueInputProduct: setTotalProduct })
    const { handleQtyChange } = useHandleChangeProduct({ setQtyProduct })
    const { handleVatChange } = useHandleChangeProduct({ setVatProduct })
    const [errorString, setErrorString] = useState<string>("");
    const modalRef = useRef<HTMLDivElement | null>(null)
    const [noteProduct, setNoteProduct] = useState<string>(dataProduct.leadProductNotes || dataProduct.productNote || "");
    const todayRange = useTodayRange();
    const { productTemp, typeActionProduct, setProductTemp } = useProductStore()
    const [dateProduct, setDateProduct] = useState<string | null>(null);
    const checkIsHarriette = checkIsCompanyHarriette(companyId, user)

    const handleModalClose = () => {
        modalRef.current?.click()
        if (typeForm === 'addLog' && onModalClose) {
            onModalClose()
        }
    }

    const handleDiscountChangeWithValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (discountType === 'PERCENTAGE') {
            const numericValue = value.replace(/[^0-9.]/g, '');
            const numberValue = parseFloat(numericValue);

            if (numberValue > 100 || (user.data.roleMaxDiscountPercentage && numberValue > user.data.roleMaxDiscountPercentage)) {
                setErrorString(intl.formatMessage({ id: "FORM.VALIDATION.MAX_DISCOUNT_PERCENTAGE" }, { title: user.data.roleMaxDiscountPercentage ? user.data.roleMaxDiscountPercentage.toString() + "%" : "100%" }));
                return;
            }

            setDiscountProduct(numericValue);
        } else {
            const newValue = changeValueIfStringIntoNumber(value)
            if (user.data.roleMaxDiscountNominal && newValue > user.data.roleMaxDiscountNominal) {
                setErrorString(intl.formatMessage({ id: "FORM.VALIDATION.MAX_DISCOUNT_NOMINAL" }, { title: currencyFormatter(user.data.roleMaxDiscountNominal.toString(), selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }) }));
                return;
            }
            handleDiscountChange(e);
        }
        setErrorString("")
    };

    const handleDiscountTypeChange = (type: 'NOMINAL' | 'PERCENTAGE') => {
        setDiscountType(type);
        setShowDiscountDropdown(false);
        setDiscountProduct('');
    };

    const toggleDiscountDropdown = () => {
        setShowDiscountDropdown(!showDiscountDropdown);
    };

    const { handleChangeValueResultTotal } = useHandleChangeResultPriceAndTotal({ discountProduct, discountType, priceProduct, qtyProduct, vatProduct, isIncludeVat, originalPriceProduct, setTotalProduct, setPriceProduct, setDiscountProduct })


    const handlePriceChangeWithOriginal = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        handlePriceChange(e);
        const currencyFormatted = currencyFormatter(value, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode);
        setOriginalPriceProduct(currencyFormatted);
    }

    const handleResetValue = () => {
        setDataProduct({
            productId: "",
            productName: "",
            productSku: "",
            productNote: "",
            leadProductNotes: "",
            productUnits: [],
            productPrice: 0,
            productVatPercentage: 0,
            productIsUsingVat: false,
            productLabels: []
        });
        setIsIncludeVat(false)
        setOriginalPriceProduct("")
        setQtyProduct("");
        setPriceProduct("");
        setTotalProduct("");
        setHppProduct("");
        setVatProduct("");
        setDiscountProduct("")
        setDiscountType('NOMINAL')
        setShowDiscountDropdown(false)
        setUnitProduct({ value: "", label: "", alias: "" });
    }

    function handleAddProduct() {
        if (changeValueIfStringIntoNumber(discountProduct) > changeValueIfStringIntoNumber(priceProduct) && discountType === 'NOMINAL') {
            Swal.fire({
                icon: "error",
                title: intl.formatMessage({ id: "FORM.LABEL.DISCOUNT_NOT_ALLOWED_GREATER_THAN_PRICE" }),
                heightAuto: false,
                target: document.getElementById('modal-add-product-pipeline'),
                confirmButtonText: 'Ok'
            })
            return
        }

        if (typeForm === 'addLog' && selectedProgress?.isRequiredUpdateProductHpp && !hppProduct) {
            Swal.fire({
                icon: "error",
                title: intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.COGS" }) }),
                heightAuto: false,
                target: document.getElementById('modal-add-product-pipeline'),
                confirmButtonText: 'Ok'
            })
            return
        }

        if (discountType === 'PERCENTAGE' && discountProduct) {
            const percentageValue = parseFloat(discountProduct);
            if (percentageValue > 100) {
                Swal.fire({
                    icon: "error",
                    title: "Discount percentage tidak boleh lebih dari 100%",
                    heightAuto: false,
                    target: document.getElementById('modal-add-product-pipeline'),
                    confirmButtonText: 'Ok'
                })
                return
            }
        }

        if (isInvalidDotInput(hppProduct) || isInvalidDotInput(priceProduct) || isInvalidDotInput(totalProduct)) {
            Swal.fire({
                icon: "error",
                title: intl.formatMessage({ id: "FORM.VALIDATION.INVALID_INPUT_DETECTED" }),
                heightAuto: false,
                target: document.getElementById('modal-add-product-pipeline'),
                confirmButtonText: 'Ok'
            })
            return
        }

        if (!dataProduct.productId) setIsDataProduct(true);
        if (dataProduct.productUnits.length > 0 && !unitProduct.value) setIsUnitProduct(true);
        const isUnitValid = dataProduct.productUnits.length === 0 || unitProduct.value;

        if (!dataProduct.productId || !isUnitValid) {
            return;
        }

        const cleanProductName = dataProduct.productName.includes(" (SKU:") ? dataProduct.productName.split(" (SKU:")[0] : dataProduct.productName;
        const newProduct = {
            productId: dataProduct.productId,
            leadProductVatPercentage: vatProduct ? Number(vatProduct) : null,
            leadProductIsUsingVat: dataProduct.productIsUsingVat,
            leadProductName: cleanProductName,
            productName: cleanProductName,
            leadProductQty: unformatNumberInput(qtyProduct),
            leadProductNotes: checkIsHarriette ? dateProduct ? formatDateWithDayName(dateProduct) : "-" : noteProduct || "-",
            leadProductPrice: priceProduct || "0",
            leadProductTotal: totalProduct,
            leadProductDiscount: discountProduct,
            leadProductDiscountType: discountType,
            edit: false,
            leadProductHpp: hppProduct || null,
            productSku: dataProduct.productSku,
            productNote: "",
            unitId: unitProduct.value && unitProduct.value !== 'pcs-id' ? unitProduct.value : null,
            unitName: unitProduct.label && unitProduct.value !== 'pcs-id' ? unitProduct.label : null,
            unitAlias: unitProduct.alias && unitProduct.value !== 'pcs-id' ? unitProduct.alias : null,
            productUnits: dataProduct.productUnits,
            leadProductIsPriceIncludeVat: isIncludeVat,
            leadProductOriginalPrice: originalPriceProduct,
            leadProductLabels: dataProduct?.productLabels || []
        };
        if (typeActionProduct === 'add') {
            setListProducts([...listProducts, { ...newProduct, leadProductId: uuidv4() }]);
            handleResetValue()
            handleModalClose()
        } else if (typeActionProduct === 'edit') {
            if (productTemp?.index !== undefined) {
                listProducts[productTemp.index] = { ...newProduct, leadProductId: productTemp.leadProductId }
                setListProducts([...listProducts])
                handleResetValue()
                handleModalClose()
            }
        }
        setProductTemp({} as ListProduct)
        setDateProduct("")
    }

    useEffect(() => {
        if (!productLoading && products.length > 0) {
            const newProductData = products.map((product: Product) => ({
                value: product.id,
                label: product.name + (product.sku ? (' (SKU: ' + product.sku + ')') : ''),
                sku: product.sku,
                note: product.note,
                productUnits: product.productUnits,
                isUsingVat: product.isUsingVat,
                price: product.price,
                labels: product.productLabels
            }));

            if (checkIsCompanyTanrise(companyId, user)) {
                if (typeActionProduct === 'edit') {
                    const foundProduct = completeProducts?.find((item: Product) =>
                        productTemp?.productId === item.id
                    )

                    if (foundProduct) {
                        const newProduct: SelectOptionProduct = {
                            value: foundProduct.id,
                            label: foundProduct.name + (foundProduct.sku ? (' (SKU: ' + foundProduct.sku + ')') : ''),
                            sku: foundProduct.sku,
                            note: foundProduct.note,
                            productUnits: foundProduct.productUnits,
                            isUsingVat: foundProduct.isUsingVat,
                            price: foundProduct.price,
                            labels: foundProduct.productLabels
                        }
                        setProductData([newProduct])
                    } else {
                        setProductData([])
                    }
                } else if (typeActionProduct === 'add') {
                    setProductData(newProductData)
                }
            } else {
                setProductData(newProductData)
            }
        }
    }, [products, productLoading, productTemp, completeProducts])

    useEffect(() => {
        if (typeActionProduct === 'edit' && productData) {
            if (productTemp && Object.keys(productTemp).length > 0) {
                const findData = productData?.find((item) => item.value === productTemp.productId)
                if (findData) {
                    setDataProduct({
                        productId: productTemp.productId,
                        productName: productTemp.leadProductName,
                        productSku: productTemp.productSku || "",
                        leadProductNotes: productTemp.leadProductNotes || "",
                        productNote: productTemp.productNote || "",
                        productUnits: productTemp.productUnits || [],
                        productPrice: Number(productTemp.leadProductPrice) || 0,
                        productVatPercentage: null,
                        productIsUsingVat: findData!.isUsingVat
                    })
                    if (checkIsHarriette) {
                        const date = productTemp.leadProductNotes && productTemp.leadProductNotes !== "-" && productTemp.leadProductNotes !== "" ? getDateOnly(productTemp.leadProductNotes) : ""
                        setDateProduct(date)
                    }
                }
                setUnitProduct({
                    value: productTemp.unitId || "pcs-id",
                    label: productTemp.unitName || "",
                    alias: productTemp.unitAlias || ""
                })
                setHppProduct(typeof productTemp.leadProductHpp === 'number' ? currencyFormatter(productTemp.leadProductHpp, true) : productTemp.leadProductHpp || "")
                setQtyProduct(typeof productTemp.leadProductQty === 'number' ? customThousandSeparatorDot(productTemp.leadProductQty) : productTemp.leadProductQty)
                setPriceProduct(productTemp.leadProductPrice as string || "")
                setTotalProduct(productTemp.leadProductTotal as string || "")
                setDiscountProduct(typeof productTemp.leadProductDiscount === 'number' ? currencyFormatter(productTemp.leadProductDiscount, true) : productTemp.leadProductDiscount || "")
                setVatProduct(productTemp.leadProductVatPercentage?.toString() || "")
                setIsIncludeVat(productTemp.leadProductIsPriceIncludeVat || false)
                setNoteProduct(productTemp.leadProductNotes || productTemp.productNote || "")
                setOriginalPriceProduct(productTemp.leadProductOriginalPrice || "")
                setDiscountType(productTemp.leadProductDiscountType || 'NOMINAL')
            }
        }
    }, [productTemp, productData, products, productLoading])

    const handleChangeProduct = (option: SelectOptionProduct) => {
        setIsIncludeVat(false)
        setOriginalPriceProduct("")
        if (checkIsCompanyElgisa(companyId, user)) {
            if (option) {
                setQtyProduct('1')
            }
        } else if (checkIsCompanyEsb(companyId, user)) {
            setQtyProduct('1')
            setHppProduct('0')
        }
        setDataProduct(
            {
                productId: option?.value || "",
                productName: option?.label || "",
                productSku: option?.sku || "",
                productNote: option?.note || "",
                leadProductNotes: "",
                productUnits: option?.productUnits || [],
                productPrice: 0,
                productVatPercentage: null,
                productIsUsingVat: option?.isUsingVat,
                productLabels: option?.labels || []
            }
        )
        if (checkIsHarriette && isValidDateFormat(option?.note || "")) {
            setDateProduct(getDateOnly(option?.note || ""))
        }
        setNoteProduct(option?.note || "")
        if ((option?.price && option?.price > 0) || option?.price === 0) {
            const formattedPrice = currencyFormatter(option?.price, selectMultiPipeline.currencyIsRounded);
            setPriceProduct(formattedPrice)
            setOriginalPriceProduct(formattedPrice)
            setQtyProduct("0")
        } else if (option?.price === null || option?.price === 0) {
            setPriceProduct("0")
            setOriginalPriceProduct("0")
        } else {
            setPriceProduct("")
            setOriginalPriceProduct("")
        }
        if (option?.isUsingVat && user.data.companyVatPercentage) {
            setVatProduct(user.data.companyVatPercentage)
        } else {
            setVatProduct("")
        }
    }

    function mapUnitSelect(data: any) {
        const mappedData = data.map((item: ProductUnits) => ({
            value: item.unit.id,
            label: item.unit.name,
            alias: item.unit.alias
        }));
        return mappedData;
    }

    useEffect(() => {
        setIsUnitProduct(false)
        if (dataProduct.productUnits.length > 0) {
            const unitSelectData = mapUnitSelect(dataProduct.productUnits)
            let finalUnitData: SelectProducUnit[] = []

            if (checkIsCompanyMeratus(companyId, user)) {
                finalUnitData = [...unitSelectData]
            } else {
                finalUnitData = [...unitSelectData, { value: 'pcs-id', label: 'PCS', alias: 'PCS' }]
            }

            setUnitData(finalUnitData)

            const defaultUnitId = '1ffd84ad-6be1-4f04-814e-dbe3b101ffa4' // TEUS (Meratus)
            const defaultUnit = finalUnitData.find(unit => unit.value === defaultUnitId)

            if (defaultUnit) {
                setUnitProduct({
                    value: defaultUnit.value,
                    label: defaultUnit.label,
                    alias: defaultUnit.alias || ""
                })
            }
        }
        if (dataProduct.productId) {
            setIsDataProduct(false)
        }
    }, [dataProduct, checkIsCompanyMeratus(companyId, user)])

    useEffect(() => {
        handleChangeValueResultTotal()
    }, [qtyProduct, priceProduct, vatProduct, discountProduct, discountType])

    useEffect(() => {
        if (originalPriceProduct && user.data.companyVatPercentage) {
            const originalPriceNumber = changeValueIfStringIntoNumber(originalPriceProduct);

            if (isIncludeVat) {
                const resultWithoutVat = originalPriceNumber / (1 + (Number(user.data.companyVatPercentage) / 100));
                setPriceProduct(currencyFormatter(resultWithoutVat, selectMultiPipeline.currencyIsRounded));
            } else {
                setPriceProduct(currencyFormatter(originalPriceNumber, selectMultiPipeline.currencyIsRounded));
            }
        }
    }, [isIncludeVat])

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (!target.closest('.input-group-append')) {
                setShowDiscountDropdown(false);
            }
        };

        if (showDiscountDropdown) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDiscountDropdown]);

    const handleCheckIfListProductExist = () => {
        if (listProducts.length > 0) {
            Swal.fire({
                title: intl.formatMessage({ id: 'FORM.VALIDATION.CANCEL' }),
                text: intl.formatMessage({ id: 'FORM.VALIDATION.DESC_CANCEL' }),
                icon: 'warning',
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.YES' }) + ", " + intl.formatMessage({ id: 'FORM.ACTION.CANCEL' }),
                cancelButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.NO' }),
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: "btn btn-active-light me-3",
                },
                reverseButtons: true,
                heightAuto: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    handleModalClose()
                    setProductTemp({} as ListProduct)
                    setDateProduct("")
                }
            })
        } else {
            handleModalClose()
            setProductTemp({} as ListProduct)
            setDateProduct("")
        }
    }

    const handleClickOutSide = (e: any) => {
        if (modalRef.current && modalRef.current === e.target) {
            e.stopPropagation();
            e.preventDefault();
            handleCheckIfListProductExist()
        }
    }

    const CustomSelectOption = (props: any) => {
        var labels = props.option?.labels?.map((label: any) => ({ text: label.label.name, color: label.label.color })) || [];

        return (
            <div className="d-flex align-items-center px-3 h-100" style={{ cursor: 'pointer' }}>
                <span className="align-middle">{props?.option.label}</span>
                {
                    labels.length > 0 && (
                        <LabelTooltip data={labels}>
                            {labels}
                        </LabelTooltip>
                    )
                }
            </div>
        );
    }

    const CustomSelectValue = (props: any) => {
        if (!props?.value) return <span>{props.placeholder}</span>
        var labels = props.value?.labels?.map((label: any) => ({ text: label.label.name, color: label.label.color })) || [];

        return (
            <div className='d-flex align-items-center'>
                <span className="align-middle">{props?.value.label}</span>
                {
                    labels.length > 0 && (
                        <LabelTooltip data={labels}>
                            {labels}
                        </LabelTooltip>
                    )
                }
            </div>
        );
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutSide)

        return () => {
            document.addEventListener('mousedown', handleClickOutSide)
        }
    }, [modalRef])

    return (
        <div className="modal fade" id='modal-add-product-pipeline' ref={modalRef} style={{ zIndex: 1200 }}>
            <div className='modal-dialog modal-dialog-centered modal-md'>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {typeActionProduct === 'add' ? intl.formatMessage({ id: "FORM.ACTION.ADD_PRODUCT" }) : intl.formatMessage({ id: "FORM.ACTION.UPDATE_PRODUCT" })}
                        </h5>
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                            onClick={handleCheckIfListProductExist}>
                            <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-2x" />
                        </div>
                    </div>
                    <div className="modal-body">
                        {/* Products */}
                        <div className="row">
                            <div className={`col-12`}>
                                <label className='form-label fs-6 fw-bolder text-dark required'>{intl.formatMessage({ id: "FORM.MENU.PRODUCTS" })}</label>
                                <div className="input-group mb-3">
                                    <VirtualizedSelect
                                        title={intl.formatMessage({ id: "FORM.MENU.PRODUCTS" })}
                                        key={
                                            window.location.pathname === '/chat' ? nanoid() : ''
                                        }
                                        options={productData}
                                        isLoading={productLoading}
                                        isClearable={false}
                                        className="w-100"
                                        placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.MENU.PRODUCTS" })}`}
                                        value={productData?.find(option => option?.value === dataProduct?.productId) ?? null}
                                        onChange={option => {
                                            handleChangeProduct(option)
                                        }}
                                        components={
                                            {
                                                Option: CustomSelectOption,
                                                SingleValue: CustomSelectValue
                                            }
                                        }
                                        estimateSize={40}
                                        defaultComponentConfig={{ isCompactMenu: false, width: '360px' }}
                                        isReselectable={true}
                                    />
                                </div>
                                {isDataProduct && (
                                    <div className='fv-plugins-message-container text-danger'>
                                        <span role='alert' className="text-danger">{intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.MENU.PRODUCTS" }) })}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* Qty and Units */}
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                {/* Qty Product */}
                                <label className='form-label fs-6 fw-bolder text-dark' style={{ float: "left" }}>{intl.formatMessage({ id: "FORM.LABEL.QUANTITY" })}</label>
                                <div className="input-group input-group-sm mb-3">
                                    <input
                                        disabled={checkIsCompanyElgisa(companyId, user) || checkIsCompanyEsb(companyId, user) || dataProduct.productId === ''}
                                        value={qtyProduct}
                                        onChange={handleQtyChange}
                                        className={clsx(
                                            'form-control form-control-lg'
                                        )}
                                        type='text'
                                        autoComplete='off'
                                        style={{ zIndex: 0, textAlign: "right" }}
                                        onInput={onlyNumberInput}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                {/* Units */}
                                <label className={`form-label fs-6 fw-bolder text-dark ${dataProduct.productUnits.length > 0 ? 'required' : ''}`}>{intl.formatMessage({ id: "FORM.LABEL.UNITS" })}</label>
                                <div className="input-group mb-3">
                                    {dataProduct.productUnits.length > 0 ?
                                        <>
                                            <Select
                                                key={
                                                    window.location.pathname === '/chat' ? nanoid() : ''
                                                }
                                                options={unitData}
                                                placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.UNITS" })}`}
                                                value={unitData.find(option => option.value === (unitProduct.value || option.value === 'pcs-id')) || null}
                                                onChange={option => {
                                                    setDiscountProduct("")
                                                    setUnitProduct({ value: option?.value || "", label: option?.label || "", alias: option?.alias || "" })
                                                }}
                                                onBlur={() => {
                                                    unitProduct.value ? setIsUnitProduct(false) : setIsUnitProduct(true);
                                                }}
                                                className="w-100"
                                            />
                                            {isUnitProduct && (
                                                <div className='fv-plugins-message-container text-danger'>
                                                    <span role='alert' className="text-danger">{intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.UNITS" }) })}</span>
                                                </div>
                                            )}
                                        </>
                                        :
                                        checkIsCompanyMeratus(companyId, user) ?
                                            null
                                            :
                                            <span className="mt-3">PCS</span>}
                                </div>
                            </div>
                        </div>
                        {/* Hpp */}
                        <div className="row">
                            {
                                user.data.is_allowed_access_hpp && selectMultiPipeline.isFeatureCogsEnabled &&
                                <div className="col-12">
                                    {/* Hpp Product */}
                                    <label className={`form-label fs-6 fw-bolder text-dark ${selectedProgress?.isRequiredUpdateProductHpp ? 'required' : ''}`} style={{ float: "left" }}>{intl.formatMessage({ id: "FORM.LABEL.HPP" })}</label>
                                    <div className="input-group input-group-sm mb-3">
                                        <input
                                            disabled={checkIsCompanyEsb(companyId, user) || dataProduct.productId === ''}
                                            value={hppProduct}
                                            onChange={handleHppChange}
                                            className={clsx(
                                                'form-control form-control-lg',
                                            )}
                                            type='text'
                                            autoComplete='off'
                                            style={{ zIndex: 0, textAlign: "right" }}
                                            required={selectedProgress?.isRequiredUpdateProductHpp}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                        {/* Price */}
                        <div className="row">
                            <div className="col-12">
                                {/* Price Product */}
                                <label className={`form-label fs-6 fw-bolder text-dark`} style={{ float: "left" }}>{checkIsCompanyEsb(companyId, user) ? "Projected revenue" : intl.formatMessage({ id: "FORM.LABEL.PRICE" }) + ` (${currencylocales.find((item) => item.currencyCode === selectMultiPipeline.currencyCode)?.currencyCode || 'IDR'})`}</label>
                                <div className="input-group input-group-sm mb-3">
                                    <input
                                        disabled={dataProduct.productId === '' || isIncludeVat || selectMultiPipeline.isDisabledPriceProduct}
                                        value={priceProduct}
                                        onChange={handlePriceChangeWithOriginal}
                                        className={clsx(
                                            'form-control form-control-lg'
                                        )}
                                        type='text'
                                        autoComplete='off'
                                        style={{ zIndex: 0, textAlign: "right" }}
                                    />
                                </div>
                                {
                                    vatProduct && (
                                        <div className="form-check form-check-sm">
                                            <input type="checkbox" id="checkbox-include-vat" className="form-check-input" checked={isIncludeVat} onChange={() => setIsIncludeVat(!isIncludeVat)} />
                                            <label className="form-check-label" htmlFor="checkbox-include-vat">
                                                {intl.formatMessage({ id: "FORM.LABEL.INCLUDE_VAT" })}
                                            </label>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        {/* Discount */}
                        {
                            !settings.is_pipeline_discount_hidden && (
                                <div className="row">
                                    <div className="col-12">
                                        {/* Discount Product */}
                                        <label className={`form-label fs-6 fw-bolder text-dark`} style={{ float: "left" }}>
                                            {intl.formatMessage({ id: "FORM.LABEL.DISCOUNT" })}
                                        </label>
                                        <div className="input-group input-group-sm mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={discountProduct}
                                                onChange={handleDiscountChangeWithValidation}
                                                disabled={dataProduct.productId === '' || isDisabledPriceProduct(user, roleId)}
                                                autoComplete='off'
                                                style={{ zIndex: 0, textAlign: "right" }}
                                                placeholder={discountType === 'PERCENTAGE' ? 'Maks. 100%' : `0 ${currencylocales.find((item) => item.currencyCode === selectMultiPipeline.currencyCode)?.currencyCode || 'IDR'}`}
                                            />
                                            <div className="input-group-append position-relative">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-secondary px-2"
                                                    onClick={toggleDiscountDropdown}
                                                    style={{ borderRadius: '0px 4px 4px 0px', border: '1px solid #ced4da' }}
                                                >
                                                    <span className="badge bg-primary me-1">
                                                        {discountType === 'PERCENTAGE' ? '%' : currencylocales.find((item) => item.currencyCode === selectMultiPipeline.currencyCode)?.currencyCode || 'IDR'}
                                                    </span>
                                                    <i className={`fas ${showDiscountDropdown ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                                                </button>
                                                {showDiscountDropdown && (
                                                    <div className="position-absolute bg-white shadow rounded border" style={{ top: '100%', right: 0, zIndex: 1050, minWidth: '120px' }}>
                                                        <div
                                                            className="px-3 py-2 cursor-pointer hover-bg-light"
                                                            onClick={() => handleDiscountTypeChange('NOMINAL')}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            Nominal
                                                        </div>
                                                        <div
                                                            className="px-3 py-2 cursor-pointer hover-bg-light border-top"
                                                            onClick={() => handleDiscountTypeChange('PERCENTAGE')}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            {intl.formatMessage({ id: "FORM.OPTION.TYPE.PERCENTAGE" })}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {errorString && (
                                            <div className='fv-plugins-message-container text-danger'>
                                                <span role='alert' className="text-danger">{errorString}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        }
                        {/* VAT */}
                        <div className="row">
                            <div className="col-12">
                                {/* VAT Product */}
                                <label className='form-label fs-6 fw-bolder text-dark'>{intl.formatMessage({ id: "FORM.LABEL.VAT" })}</label>
                                <div className="input-group input-group-sm mb-3">
                                    <input
                                        disabled={true}
                                        value={vatProduct}
                                        onChange={handleVatChange}
                                        className={clsx(
                                            'form-control form-control-lg',
                                        )}
                                        type='text'
                                        autoComplete='off'
                                        style={{ zIndex: 0, textAlign: "right" }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Total */}
                        <div className="row">
                            <div className="col-12">
                                {/* Total */}
                                <label className='form-label fs-6 fw-bolder text-dark'>{intl.formatMessage({ id: "FORM.LABEL.TOTAL" }, { title: "" }) + ` (${selectMultiPipeline.currencyCode})`}</label>
                                <div className="input-group input-group-sm mb-3">
                                    <input
                                        disabled={true}
                                        value={totalProduct}
                                        onChange={handleNominalChange}
                                        className={clsx(
                                            'form-control form-control-lg',
                                        )}
                                        type='text'
                                        name='nominal'
                                        autoComplete='off'
                                        style={{ zIndex: 0, textAlign: "right" }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Notes */}
                        <div className="row">
                            {/* Second Row - Notes, VAT, and Total */}
                            {
                                checkIsHarriette ? (
                                    <div className="col-12">
                                        <label className='form-label fs-6 fw-bolder text-dark' htmlFor="dateProduct">{intl.formatMessage({ id: "FORM.LABEL.NOTE" })}</label>
                                        <DatePicker
                                            id="dateProduct"
                                            ranges={todayRange}
                                            editable={false}
                                            format="dd MMM yyyy"
                                            value={dateProduct ? new Date(dateProduct) : null}
                                            defaultValue={null}
                                            style={{ width: "100%", zIndex: 0 }}
                                            container={document.getElementById('modal-add-product-pipeline') as HTMLElement}
                                            onChange={(value: any) => {
                                                if (value) setDateProduct(moment(value).format('YYYY-MM-DD'))
                                                else setDateProduct(null)
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div className="col-12">
                                        {/* Notes Product */}
                                        <label className='form-label fs-6 fw-bolder text-dark' htmlFor="noteProduct">{intl.formatMessage({ id: "FORM.LABEL.NOTE" })}</label>
                                        <textarea className='form-control form-control-lg' name="noteProduct" id="noteProduct" value={noteProduct} onChange={(e) => setNoteProduct(e.target.value)}></textarea>
                                    </div>
                                )
                            }
                        </div>
                        {/* Btn Simpan Product Form */}
                        <div className="row">
                            <div className="col-12 my-2">
                                <button type="button" className="btn btn-light-primary" style={{ width: '100%' }} onClick={handleAddProduct}>
                                    {intl.formatMessage({ id: 'FORM.ACTION.SAVE' })}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className='btn btn-light' onClick={() => {
                            handleModalClose()
                            setProductTemp({} as ListProduct)
                            setDateProduct("")
                        }}>
                            {intl.formatMessage({ id: "FORM.ACTION.CLOSE" })}
                        </button>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ProductPipelineMain